import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Artistic%20Korean%20manhwa%20style%20illustration%2C%20abstract%20warm%20gradient%20background%20with%20soft%20brush%20strokes%2C%20ink%20wash%20effect%20in%20cream%20peach%20and%20warm%20gray%20tones%2C%20elegant%20minimalist%20composition%2C%20subtle%20paper%20texture%2C%20dreamy%20atmospheric%20mood%2C%20digital%20art%20with%20traditional%20Korean%20painting%20influence%2C%20no%20text%20or%20characters&width=1600&height=900&seq=hero-bg-home&orientation=landscape"
        alt="韩漫之家 - 好看韩国漫画在线阅读平台"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/30"></div>

      <div className="absolute inset-0 flex items-center justify-center">
        <div className="text-center px-4 w-full max-w-3xl">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-4 leading-tight">
            好看韩国漫画
            <span className="block text-2xl md:text-3xl lg:text-4xl font-medium mt-2 text-accent-300">
              韩漫在线免费阅读
            </span>
          </h1>
          <p className="text-background-200 text-sm md:text-lg max-w-xl mx-auto mb-8 leading-relaxed">
            高清韩漫大全，尽在韩漫之家。每日更新热门韩国漫画，为您提供稳定优质的阅读体验。
          </p>
          <div className="flex items-center justify-center gap-4 flex-col sm:flex-row">
            <Link
              to="/category/love"
              className="px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer shadow-sm"
            >
              立即阅读
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 rounded-full border border-background-50/40 text-background-50 font-medium text-sm hover:bg-background-50/10 transition-all whitespace-nowrap cursor-pointer"
            >
              了解更多
            </Link>
          </div>
          <div className="flex items-center justify-center gap-6 mt-10">
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">1000+</p>
              <p className="text-xs text-background-300 mt-1">高清韩漫</p>
            </div>
            <div className="w-px h-10 bg-background-50/20"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">50万+</p>
              <p className="text-xs text-background-300 mt-1">忠实读者</p>
            </div>
            <div className="w-px h-10 bg-background-50/20"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">每日</p>
              <p className="text-xs text-background-300 mt-1">稳定更新</p>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-s-line text-background-50/60 text-2xl"></i>
      </div>
    </section>
  );
}